import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/home/Hero';
import FeaturedCourse from '../components/home/FeaturedCourse';
import AboutPreview from '../components/home/AboutPreview';
import Programs from '../components/home/Programs';
import TestimonialSlider from '../components/common/TestimonialSlider';
import ContactPreview from '../components/home/ContactPreview';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>KSARC - Structural Design Academy & Research Centre</title>
        <meta name="description" content="KSARC provides excellent education in structural engineering, civil engineering, and competitive exam preparation including TNPSC coaching." />
      </Helmet>
      
      <Hero />
      <FeaturedCourse />
      <AboutPreview />
      <Programs />
      <TestimonialSlider 
        title="What Our Students Say"
        subtitle="Hear from those who have experienced our training programs"
      />
      <ContactPreview />
    </>
  );
};

export default HomePage;
